// Imports => React
import { useEffect, useMemo } from "react";
import { withStore } from "@stores";
import { observer } from "mobx-react-lite";
import { Fade } from "react-awesome-reveal";
import clsx from "clsx";

// Imports => Constants
import { TABS, TITLES } from "@constants";
import { THEMES } from "@opp/ui-kit";

import styles from "./dashboard.module.scss";

// Imports => Utilities
import { AcSetDocumentTitle } from "@utils";
import { AcIsSet, AcGetHumanizedGreeting, AcSanitize } from "@opp/ui-kit";

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcHeading,
  AcTabContainer,
} from "@opp/ui-kit";
import { AcTranslateTabs } from "../../utilities/ac-translate-consts";
import { withTranslation } from "react-i18next";

const _CLASSES = {
  MAIN: "ac-page ac-dashboard",
};

const AcDashboard = ({ store: { profile }, t }) => {
  const { current_merchant_profiles } = profile;

  useEffect(() => {
    AcSetDocumentTitle(TITLES.DASHBOARD);
  }, []);

  const renderTitle = useMemo(() => {
    let title = "&nbsp;";
    let subtitle = `${t("greeting." + AcGetHumanizedGreeting(), {
      ns: "common",
    })}`;

    const profile =
      (current_merchant_profiles && current_merchant_profiles.merchant) || null;

    if (AcIsSet(profile)) {
      subtitle = `${subtitle},`;
      title = profile.name;
      title = AcSanitize(title);
    }

    let result = (
      <>
        <small>{subtitle}</small>
        {title && (
          <Fade duration={350} key={title}>
            <em
            className={styles.limitName}
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          </Fade>
        )}
      </>
    );

    return (
      <AcHeading
        theme={THEMES.DARK}
        rank={1}
        className={"h-margin-y-0 h-margin-top-15"}
      >
        {result}
      </AcHeading>
    );
  }, [current_merchant_profiles]);

  const renderTabs = () => {
    let collection = TABS.DASHBOARD;
    collection = AcTranslateTabs(t, collection);
    return <AcTabContainer disableIndicator collection={collection} />;
  };

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  }, []);

  return (
    <div className={getMainClassNames}>
      <AcContainer fluid>
        <AcRow className={"h-margin-bottom-40"}>
          <AcColumn xs={12}>{renderTitle}</AcColumn>
        </AcRow>
      </AcContainer>

      {renderTabs()}
    </div>
  );
};

export default withTranslation(["tabs", "common"])(
  withStore(observer(AcDashboard))
);
